<div class="title-bar">
    <h2 class="global-title">
        Quotation templates
    </h2>
</div>
<p-confirmDialog header="Delete a quotation template"></p-confirmDialog>
<ng-container *ngIf="templates">
    <p-table selectionMode="single" [value]="templates">
        <ng-template pTemplate="header">
            <tr>
                <th [style]="{width: '80px'}">
                    ID
                </th>
                <th>
                    Name
                </th>
                <th>
                    Title
                </th>
                <th [style]="{width: '85px'}">
                    Language
                </th>
                <th>
                    School
                </th>
                <th [style]="{width: '80px'}">
                    Action
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
            <tr [pSelectableRow]="template">
                <td>
                    {{template.id}}
                </td>
                <td class="name-box">
                    <a routerLink="/management/edit-quotation-template/{{template.id}}">
                        {{template.name}}
                    </a>
                </td>
                <td>
                    {{template.description}}
                </td>
                <td>
                    {{template.language.name}}
                </td>
                <td>
                    {{template.school.name}}
                </td>
                <td>
                    <!-- <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deteteTemplate(template.id)"></p-button> -->
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>
